import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { useAdsType } from '../useAdsType';
const AnonOrUserUnit = (_param)=>{
    var { anon: Anon , user: User  } = _param, rest = _object_without_properties(_param, [
        "anon",
        "user"
    ]);
    const adType = useAdsType();
    if (adType === 'off') {
        return null;
    }
    if (adType === 'user') {
        return /*#__PURE__*/ React.createElement(User, _extends({}, rest));
    }
    return /*#__PURE__*/ React.createElement(Anon, _extends({}, rest));
};
AnonOrUserUnit.displayName = 'AnonOrUserUnit';
export default AnonOrUserUnit;
